import { commonGetType } from "./common.type";
import { _get, _put } from "lib/rest";

////////////////////////////////////////////////////////////////////////////////
// 유저 알람
////////////////////////////////////////////////////////////////////////////////
export const getUserAlarms = () => _get(`/accounts/alarms/`);

//여러개 업데이트
export const updateUserAlarmRead = (data: { id: number[] }) =>
  _put("/accounts/alarms/update/", data);

export const readOneUserAlarm = (id: number) => _put(`/accounts/alarms/${id}/`);

////////////////////////////////////////////////////////////////////////////////
// 프로젝트 알람
////////////////////////////////////////////////////////////////////////////////

export const getProjectAlarms = (pid: number, data?: commonGetType) =>
  _get(`/sentiment/project/${pid}/alarms/`, { data });

//여러개 업데이트
export const updateProjectAlarmRead = (pid: number, data: { id: number[] }) =>
  _put(`/sentiment/project/${pid}/alarms/update/`, data);

//한개 업데이트트
export const readOneProjectAlarm = (pid: number, id: number) =>
  _put(`/sentiment/project/${pid}/alarms/${id}/`);
